import _ from 'lodash';
import * as d3 from 'd3';
import { intcomma } from 'journalize';

/*let width = 0
let height = 0
let chartWidth = 0
let chartHeight = 0*/
const field = "cumulative_both"
const OVERLAP_THRESHOLD = 0.03
const xScale = d3.scaleLinear()
const yScale = d3.scaleLinear()
const colorScale = d3.scaleOrdinal()

const formatPercent = d3.format(",.0%")
const formatPercent2 = function(d) {
  var percent = (d * 100.0).toFixed(1) + '%';


  return percent
}
const formatVoters = d3.format(",d")
const parseYear = d3.timeParse('%Y')
const formatYear = d3.timeFormat('’%y')
const years = ['2010', '2012', '2014', '2016']
const headerLabels = ["year", "votes", "percent"]
const pinch = 20

const mobile = (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1)

export default () => ({

  render() {

    let props = {
        width: 0,
        height: 0,
        margin: {},
        yTicks: 0,
        tooltip: false,
    }

    function linechart(container) {
      const data = container.datum()
      //console.log(data)
      const current = data.current
      const historic = data.historic

      const chartWidth = props.width - props.margin.right - props.margin.left
      const chartHeight =  props.height - props.margin.top - props.margin.bottom;
      function enter() {

        const svg = container.selectAll('svg').data([data])
        const svgEnter = svg.enter().append("svg").attr("class", "line-svg")
        const gEnter = svgEnter.append('g')

        gEnter.append("g").attr("class", "annotations")
        gEnter.append("g").attr("class", "axis--x axis")
        gEnter.append("g").attr("class", "axis--y axis")
        gEnter.append("g").attr("class", "dotted-lines")
        gEnter.append("g").attr("class", "lines")
        gEnter.append("g").attr("class", "tooltip-circles")
        gEnter.append("g").attr("class", "svg-overlay")

      }

      function updateScales() {

        //console.log(d3.extent(_.flatten(data.map(arr => d3.extent(arr.values, d => d.day))))
        const xExtent = d3.extent(_.flatten(current.map(arr => d3.extent(arr.values, d => d.day))), d => d)
        //const xExtent = data[].values.map(d => parseYear(d.year))
        xScale
          .domain([1,12])
          .range([0, chartWidth])

        //const yMax = d3.max(_.flatten(data.map(arr => d3.max(arr.values, d => d.cumulative_in_person))), d => d)
        //const yMax = d3.max(_.flatten(data.map(arr => d3.max(arr.values, d => d[field]/d['reg_voters']))), d => d)
        //console.log(yMax)
        yScale
          .domain([0, 0.6])
          .rangeRound([chartHeight, 0])
          .nice()

        const svg = container.select("svg")
        const g = svg.select('g')

        const xAxisG = g.select(".axis--x")
        const yAxisG = g.select(".axis--y")

        const xAxis = d3.axisBottom(xScale)
          //.tickFormat(formatYear)
          //.ticks(6)

        const yAxis = d3.axisLeft(yScale)
          .tickFormat(formatPercent)
          .ticks(props.yTicks)
          .tickSize(0)
          //.ticks(3)

        const xAxisGEnter = xAxisG
          .attr('transform', `translate(0, ${chartHeight})`)
          .call(xAxis)

        const yAxisGEnter = yAxisG
          .attr('transform', `translate(${-props.margin.left/4}, 0)`)
          .call(yAxis)

        yAxisGEnter.selectAll(".tick:first-of-type text").remove()

        const xLabel = xAxisG.selectAll(".tick:first-of-type").selectAll(".x-label").data(["Day"])
        const xLabelEnter = xLabel
          .enter()
          .append("text")
          .attr("class", "x-label")
        .merge(xLabel)
          .text(d => d)
          .attr("dy", "0.71em")
          .attr("y", 9)
          .attr("x", (-props.margin.left/4) - 5)
          .attr("text-anchor", "end")
      }

      function updateDom() {
          const svg = container.select("svg")

          svg
            .attr('width', props.width)
            .attr('height', props.height)

          const g = svg.select('g')

          g.attr('transform', `translate(${props.margin.left}, ${props.margin.top})`)

          const annotations = g.select(".annotations")
          const lines = g.select(".lines")
          const dottedlines = g.select(".dotted-lines")
          const circles = g.select(".tooltip-circles")
          const overlayG = g.select(".svg-overlay")

          const annotation = annotations.selectAll(".annotation")
            .data(['Total early voting turnout in:'])

          annotation
            .enter()
            .append("text")
            .attr("class", "annotation")
          .merge(annotation)
            .text(d => d)
            .attr("x", chartWidth + 10)
            .attr("y", yScale(d3.max(historic, d => d['ev_per'])) - 40)
            .attr("dy", "1.15em")
            .call(wrap, 100)

          const line = d3.line()
            .x(d => xScale(d.day))
            .y(d => yScale(d[field]/d['reg_voters']))

          const area = d3.area()
            .x(d => xScale(d.day))
            .y0(chartHeight)
            .y1(d => yScale(d[field]/d['reg_voters']))


          let currYear = current.map(d => d.values).slice(0,1)[0]
          //console.log(currYear[currYear.length-1]['number_in_person'])
          if (currYear[currYear.length-1]['number_in_person'] == 0) {
            currYear.splice(-1,1)
            // console.log(currYear)
          }

          const lineG = lines.selectAll('.line-g')
            .data([currYear])

          const lineGEnter = lineG
              .enter()
              .append("g")
              .attr("class", 'line-g')

          lineGEnter
            .append('path')
            .attr('class', 'line')

          lineGEnter
            .append('path')
            .attr('class', 'area')

          // lineGEnter
          //   .append('rect')
          //   .attr('class', 'line-rect')

          lineGEnter
            .append('rect')
            .attr('class', 'percent-rect')

          /*const lineLabel = lineGEnter
            .append('text')
            .attr('class', 'line-label')*/

          const percentLabel = lineGEnter
            .append('text')
            .attr('class', 'percent-label')

          const lineGUpdate = lineGEnter.merge(lineG)

          lineGUpdate
            .select(".line")
            .attr('d', line)
            //.attr('stroke', (d, i) => colorScale(d[0]['year']))
            /*.attr("stroke-dasharray", function(d) {

              //console.log(d3.select(this).getTotalLength())
              if (d[d.length-1]['number_in_person'] == 0) {
                console.log(this.getTotalLength)
                return `${this.getTotalLength() - xScale(2)} 6 4 6 4 6 4 6 4 6`
              }
            })*/


          lineGUpdate
            .select(".area")
            .attr('d', area)

          /*lineGUpdate
            .select(".line-label")
            .text(d => `Day ${d.length}, ${d[0]['year']}`)
            .attr("x", d => xScale(d[d.length-1]['day']) + 7.5)
            .attr("y", d => yScale(d[d.length-1][field]/d[d.length-1]['reg_voters']))*/

          lineGUpdate
            .select(".percent-label")
            .text(d => formatPercent2(d[d.length-1][field]/d[d.length-1]['reg_voters']))
            .attr("x", d => xScale(d[d.length-1]['day']) - 10)
            .attr("y", d => yScale(d[d.length-1][field]/d[d.length-1]['reg_voters']) - 10)

          //console.log(lineLabel)
          // const lineWidth = lineGUpdate
          //   .select(".line-label").node().getBoundingClientRect().width
          // const lineHeight = lineGUpdate
          //   .select(".line-label").node().getBoundingClientRect().height
          const percentWidth = lineGUpdate
            .select(".percent-label").node().getBoundingClientRect().width
          const percentHeight = lineGUpdate
            .select(".percent-label").node().getBoundingClientRect().height

          //console.log(rectWidth)
          //console.log(rectHeight)
          /*lineGUpdate
            .select(".line-rect")
            .attr("width", lineWidth*1.1)
            .attr("height", lineHeight*0.9)
            .attr("x", d => xScale(d[d.length-1]['day']) - (lineWidth*1.1))
            .attr("y", d => yScale(d[d.length-1][field]/d[d.length-1]['reg_voters']) - 25)*/

          lineGUpdate
            .select(".percent-rect")
            .attr("width", 50)
            .attr("height", 20)
            .attr("x", d => xScale(d[d.length-1]['day']) - 55)
            .attr("y", d => yScale(d[d.length-1][field]/d[d.length-1]['reg_voters']) - 21)

          const dottedlineG = dottedlines.selectAll('.dotted-line-g')
            .data(historic)

          const dottedlineGEnter = dottedlineG
              .enter()
              .append("g")
              .attr("class", 'dotted-line-g')

          dottedlineGEnter
            .append('line')
            .attr('class', 'dotted-line')

          const dottedlineLabel = dottedlineGEnter
            .append('text')
            .attr('class', 'dotted-line-label')


          const dottedlineGUpdate = dottedlineGEnter.merge(dottedlineG)
          dottedlineGUpdate
            .select(".dotted-line")
            .attr("x1", 0)
            .attr("x2", chartWidth)
            .attr("y1", d => yScale(d['ev_per']))
            .attr("y2", d => yScale(d['ev_per']))
            //.attr('stroke', (d, i) => colorScale(d[0]['year']))

          dottedlineGUpdate
            .select(".dotted-line-label")
            .text(d => d['year'] == '2014' ? `${d['year']} midterm` : `${d['year']} presidential`)
            .attr("x", chartWidth + 10)
            .attr("y", function(d,i,nodes) {
              let prev
              let prevprev
              if (i > 1) {
                prev = d3.select(nodes[i-2])
                prevprev = d3.select(nodes[i-1])
                const curr_per = d['ev_per']
                const prev_per = prev.data()[0]['ev_per']
                const prevprev_per = prevprev.data()[0]['ev_per']
                if (Math.abs(curr_per - prev_per) < OVERLAP_THRESHOLD) {
                  const avg = (curr_per + prev_per) / 2
                  const height = yScale(yScale.domain()[1] - OVERLAP_THRESHOLD)
                  //d3.select(this).attr("y", yScale(avg) + (curr_per > prev_per ? -height/2 : height/2))
                  prev.attr("y", d => yScale(avg) + (curr_per < prev_per ? -height/2 : height/2))
                  return yScale(avg) + (curr_per > prev_per ? -height/2 : height/2)
                }
                if (Math.abs(curr_per - prevprev_per) < OVERLAP_THRESHOLD) {
                  const avg = (curr_per + prevprev_per) / 2
                  const height = yScale(yScale.domain()[1] - OVERLAP_THRESHOLD)
                  //d3.select(this).attr("y", yScale(avg) + (curr_per > prev_per ? -height/2 : height/2))
                  prevprev.attr("y", d => yScale(avg) + (curr_per < prevprev_per ? -height/2 : height/2))
                  return yScale(avg) + (curr_per > prevprev_per ? -height/2 : height/2)
                }

              }
              return yScale(d['ev_per'])
            })
            //.attr('fill', (d, i) => colorScale(d[0]['year']))
            .attr("text-anchor", d => d['year'] == '2018' ? 'end' : 'start')


          const circle = circles.selectAll(".tooltip-circle")
          	.data(current.map(d => d.values).slice(0,1))

          const circleEnter = circle
          	.enter()
          	.append("circle")
          	.attr("class", d => `tooltip-circle`)
            .attr("data-class", d => d[0]['year'])
          .merge(circle)
          	.attr("r", 4)
          	.attr("stroke", d => colorScale(d))
            .attr("cx", d => xScale(d.length))
            .attr("cy", d => yScale(d[d.length-1][field]/d[d.length-1]['reg_voters']))



          const overlay = overlayG.selectAll(".overlay-rect")
          	.data([data])

          overlay
          	.enter()
          	.append("rect")
          	.attr("class", d => "overlay-rect")
          	.attr("data-class", d => d.current[0].values[0]['county'].toLowerCase())
          .merge(overlay)
          	.attr("width", chartWidth)
          	.attr("height", chartHeight)
          	.on("mousemove", function() {
              if (!mobile && props.tooltip) {
                mouseMoveHandler(this)
              }
          	})
          	.on("mouseout", () => {
              //console.log("why am inot getting this mouseout handlerrr")
              if (props.tooltip) {

          		  mouseOutHandler()
              }
          	})
            .on("touchstart", function () {
              if (mobile && props.tooltip) {
                mouseMoveHandler(this)
              }
            })
            .on("touchmove", function () {
              if (mobile && props.tooltip) {
                mouseMoveHandler(this)
              }
            })
            .on("touchend", () => {
              //console.log("why am inot getting this mouseout handlerrr")
              if (props.tooltip) {

                mouseOutHandler()
              }
            })

        	function offset(el) {

    		    var rect = el.getBoundingClientRect(),
    		    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    		    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    		    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
    			}

          function mouseMoveHandler(that) {
            xScale
                .domain([1,12])
                .range([0, chartWidth])

            yScale
              .domain([0, 0.6])
              .rangeRound([chartHeight, 0])
              .nice()

              const tooltip = d3.select(".tooltip")
              const day = Math.round(xScale.invert(d3.mouse(that)[0]))
              const daysAvailable = current[0].values//.length
              if (day > daysAvailable.length) {
                mouseOutHandler()
              } else {
                const early_voters = daysAvailable[day - 1][field]/daysAvailable[day - 1]['reg_voters']

                circleEnter
                  .attr("cx", () => xScale(day))
                  .attr("cy", () => yScale(early_voters))
                //console.log(yScale())

                tooltip
                  .style("visibility", "visible")
                  .style("left", () => {
                    const tooltipwidth = tooltip.node().getBoundingClientRect().width
                    const xOffset = offset(document.getElementsByClassName(`${d3.select(that).attr("data-class")}-chart`)[0]).left + props.margin.left - tooltipwidth/2
                    let left = xScale(day) + xOffset

                    if (left < 5) {
                      left = 5
                    } else if (left + tooltipwidth + 5 > window.innerWidth) {
                      left = window.innerWidth - tooltipwidth - 5
                    }
                    return `${left}px`
                  })
                  .style("top", () => {
                    const tooltipheight = tooltip.node().getBoundingClientRect().height
                    const yOffset = offset(document.getElementsByClassName(`${d3.select(that).attr("data-class")}-chart`)[0]).top + props.margin.top - tooltipheight
                    //const max_early_voters = d3.max(current.map(d => d.values[day-1]), d => d ? d[field]/d['reg_voters'] : 0)
                    return `${yScale(early_voters) + yOffset - 15}px`

                  })

                  tooltip.select(".tooltip-day")
                    .text(d => `Day ${day}`)

                  let row = tooltip.select("table").select("tbody").selectAll(".tooltip-row")
                    .data(current.length == 1 ? current : current.slice(0,2))

                  row.exit().remove()
                  const rowEnter = row
                    .enter()
                    .append("tr")
                    .attr("class", d => `tooltip-row y${d.key}`)

                  let cell = rowEnter.selectAll(".tooltip-cell")
                    .data(headerLabels)

                  const cellEnter = cell
                    .enter()
                    .append("td")
                    .attr("class", d => `cell-${d} tooltip-cell`)
                  .merge(cell)

                  const rowUpdate = rowEnter.merge(row)

                  rowUpdate.select(".cell-year")
                    .text(d => d['key'])

                  rowUpdate.select(".cell-votes")
                    .text(d => formatVoters(d.values[day-1][field]))

                  rowUpdate.select(".cell-percent")
                    .text(d => formatPercent2(d.values[day-1]['cumulative_per']))
              }
          }

          function mouseOutHandler() {
            d3.select(".tooltip")
                .style("visibility", "hidden")

            const daysAvailable = current[0].values
            circleEnter
             //.attr("opacity", d => d == '2018' ? 1 : 0)
              .attr("cx", () => xScale(daysAvailable.length))
              .attr("cy", () => yScale(daysAvailable[daysAvailable.length - 1]['cumulative_per']))
          }




      }

      enter()
      updateScales()
      updateDom()

    }

    linechart.props = (obj) => {
      if (!obj) return props;
      props = Object.assign(props, obj);
      return linechart;
    }
    return linechart
  },

  draw() {
    const chart = this.render()
      .props(this._props);

    this._selection
      .datum(this._data)
      .call(chart);
  },

  // We use the create method to initially draw our chart
  // Unlike the update and resize methods, this method expects our actual html selector
  // (which is needed by our chart function to actually draw the chart)
  // We also pass in our data and custom props object here.
  create(selection, data, props) {
    this._selection = selection;
    this._data = data;
    this._props = props || {};

    this.draw();
  },

  // Method that is useful for updating our chart with new data.
  update(data) {
    this._data = data;
    this.draw();
  },

  // Helper method to resize our chart and make it responsive.
  resize() {
    this.draw();
  },
})

function wrap(text, width) {
  text.each(function() {
    var text = d3.select(this),
        words = text.text().split(/\s+/).reverse(),
        word,
        line = [],
        lineNumber = 0,
        lineHeight = 1.15,
        x = text.attr("x"),
        y = text.attr("y"),
        dy = parseFloat(text.attr("dy")),
        tspan = text.text(null).append("tspan").attr("x", x).attr("y", y).attr("dy", dy + "em");
    while (word = words.pop()) {
      line.push(word);
      tspan.text(line.join(" "));
      if (tspan.node().getComputedTextLength() > width) {
        line.pop();
        tspan.text(line.join(" "));
        line = [word];
        tspan = text.append("tspan").attr("x", x).attr("y", y).attr("dy", ++lineNumber * lineHeight + dy + "em").text(word);
      }
    }
  });
}
